export function getUser(email) {
    let { getUserRequest, getUserError, getUserResult } = this.props

    this.doAction(this.WEB_REQUEST_URL + 'get_user', this.createBundle('get_user', { email }, this.GET, getUserRequest, getUserResult, getUserError))
}
